export default __webpack_public_path__ + "static/simple-9bbb8d982437877ce1ae4c3a506e72f0.png";